import styled from "styled-components";

export const CtaWrapper = styled.div<{ $isMobile: boolean }>`
  display: flex;
  justify-content: ${({ $isMobile }) => ($isMobile ? "stretch" : "flex-end")};
  margin: ${({ theme, $isMobile }) => ($isMobile ? theme.spacing(2) : 0)};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const CtaButton = styled.button<{ $isMobile: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $isMobile }) => ($isMobile ? "center" : "flex-start")};
  gap: ${({ theme }) => theme.spacing(1)};
  width: ${({ $isMobile }) => ($isMobile ? "100%" : "auto")};
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.mediumBlue};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.mediumBlue};
  border-radius: ${({ $isMobile, theme }) =>
    $isMobile ? theme.borderRadius.medium : theme.borderRadius.full};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightBlue};
  }
`;

export const HelperText = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.darkGray};
`;
